/**
 * Contains the key used to load a specific version of the cookie consent integration.When an empty string is used, we won't try to load anything
 */ export var COOKIE_CONSENT_KEY = 'COOKIE_CONSENT_KEY';
